/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FirmwareDto } from '../../models/firmware-dto';

export interface GetFirmwareById$Params {
  id: number;
}

export function getFirmwareById(http: HttpClient, rootUrl: string, params: GetFirmwareById$Params, context?: HttpContext): Observable<StrictHttpResponse<FirmwareDto>> {
  const rb = new RequestBuilder(rootUrl, getFirmwareById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FirmwareDto>;
    })
  );
}

getFirmwareById.PATH = '/firmwares/{id}';
